import commonJs from "../../../assets/js/common/common.js";
import index from '../pages/index/index'
import user from '../pages/user'
import contentCreate from '../pages/createCenter/contentCreate'
import contentManage from "../pages/createCenter/contentManage"
import contentManageBK from "../pages/createCenter/contentManageBK"
import contentCarry from "../pages/createCenter/contentCarry"
import article from '../pages/article/index'
// import article from '../../../components/article'
import disease from '../pages/disease'
import vaccines from '../pages/vaccines'
import healthcare from '../pages/healthcare'
import commonwiki from '../pages/commonwiki'

// import symptom from '../pages/symptom'
import symptom from "../../../components/symptom";
import personalCenter from '../pages/personalCenter/personalCenter'
import personalCenterDetail from '../pages/personalCenter/detail'
import personalCenterUpdate from '../pages/personalCenter/update'
import logo from '../../../components/logo.vue'
// 药品百科
import encyclopedia from '../pages/encyclopediaMedicine/index'
import { getContentUserInfo } from '../../../api/user'

var routes = [
    {
      path: "/logo",
      name: "logo",
      component: logo,
      meta: {
        title: "登录",
      },
    },{
      path: "/",
      name: "user",
      component: user,
      redirect: "/index",
      children: [{
        path: "/index",
        name: "index",
        component: index,
        meta: {
          title: "首页",
        }
      }, {
        path: "/create",
        name: "contentCreate",
        // component: contentCarry,
        component: contentCreate,
        meta: {
          title: "内容创作",
        },

      }, {
        path: "/manage",
        name: "contentManage",
        component: contentManage,
        meta: {
          title: "内容管理",
        },
      }, {
        path: "/manageBK",
        name: "contentManageBK",
        component: contentManageBK,
        meta: {
          title: "百科管理",
        },
      }, {
        path: "/contentCarry",
        name: "contentCarry",
        component: contentCarry,
        meta: {
          title: "内容搬运",
        },
      }, {
        path: "/personalCenter",
        name: "personalCenter",
        component: personalCenter,
        redirect: "detail",
        children: [{
          path: '/personalCenter/detail',
          name: 'personalCenterDetail',
          component: personalCenterDetail,
          meta: {
            title: "个人中心",
          },
        }, {
          path: '/personalCenter/update',
          name: 'personalCenterUpdate',
          component: personalCenterUpdate,
          meta: {
            title: "个人中心",
          },
        }, ]
      }, {
        path: '/article',
        name: 'article',
        component: article,
        meta: {
          title: query => {
            var dict = { 1:'图文', 2:'搭配', 3:'京装', 4:'帮助', 5:'单空间', 6:'整层', 7:'视频' };
            return query.articleType == 7 ? dict[query.articleType] : dict[query.articleType]+'文章';
          },
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      },{
        path: '/wiki',
        name: 'wiki',
        component: disease,
        meta: {
          title: '疾病百科',
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      },{
        path: '/symptom',
        name: 'symptom',
        component: symptom,
        meta: {
          title: '症状百科',
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      },
      {
        path: '/drugsEncyclopedia',
        name: 'drugsEncyclopedia',
        component: encyclopedia,
        meta: {
          title: '药品百科',
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      },
      {
        path: '/vaccine',
        name: 'vaccine',
        component: vaccines,
        meta: {
          title: '疫苗百科',
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      },
      {
        path: '/healthcare',
        name: 'healthcare',
        component: healthcare,
        meta: {
          title: '保健百科',
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      },
      {
        path: '/commonwiki',
        name: 'commonwiki',
        component: commonwiki,
        meta: {
          title: '百科',
          upMenuTitle: [{ title: '创作中心', url: '', isMenu: false, }, { title: '内容创作', url: '/create' }],
          keepAlive: false // 不需要缓存
        }
      }
    ]
    },
    // {
    //   path: "*",
    //   redirect: "/error",
    // }, //路由按顺序从上到下，依次匹配。最后一个*能匹配全部，然后重定向到主页面
  ];

const whiteList = [
  '/logo',
  '/index',
];

// 第一次认证
const permission_for_first_audit = [
  '/logo',
  '/index',
  '/personalCenter/update',
];
// 未认证
const permission_for_no_audit = [
  '/logo',
  '/index',
  '/personalCenter/detail',
  '/personalCenter/update',
];
// 审核中的
const permission_for_no_auditing = [
  '/logo',
  '/index',
  '/personalCenter/detail',
];

// eslint-disable-next-line no-undef
let router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});
router.beforeEach(async (to, from, next) => {
  // 判断touter.app是否为null 否则man端浏览器后退报错
  if (!router.app){
    return
  }

  var store = router.app ? router.app.$options.store : {};
  var userInfo = store.getters.userInfo;
  if(!to.query?.tenantid && to.query?.tenantid=='' ) {
    window.location.href = '/index?tenantid=287';
    return;
  }
  if(!userInfo){
    try{
      var res = await getContentUserInfo({
        tenantId: String(commonJs.getTenantId()),
      })
    }catch(e){
      console.log(e);
      res = {};
    }
    userInfo = res;
    sessionStorage.setItem('user_identity',res.identity);
    sessionStorage.setItem('user_pin',res.pin);
    await store.dispatch('login', userInfo)
  }
  if(to.matched.length == 0){
    next({
      path: '/index',
      query: {
        ...to.query,
        tenantid: commonJs.getTenantId(),
      },
    });
    return;
  }

  if (to.path != '/logo' && (to.query.tenantid === undefined && to.query.tenantId === undefined)) {
    next({
      path: to.path,
      query: {
        ...to.query,
        tenantid: commonJs.getTenantId(),
      },
    });
  } else {
    if(to.path != '/logo' && to.path != '/index'){
      var toPath = to.path;
      if(userInfo && userInfo.auditStatus != 2){
        if(userInfo.auditStatus === undefined || userInfo.auditStatus === 0){
          permission_for_first_audit.indexOf(toPath) == -1 ? next('/index') : next();
          return;
        }else if(userInfo.auditStatus == 1){// 正在审核中...
          toPath = permission_for_no_auditing.indexOf(toPath) == -1 ? '/index' : next();
        }else {
          toPath = permission_for_no_audit.indexOf(toPath) == -1 ? '/index' : next();
        }
        next({
          path: toPath,
          query: {
            ...to.query,
            tenantid: commonJs.getTenantId(),
          },
        });
      }else{
        next();
      }
    }else{
      next();
    }
  }
});
window.dsRouter = router;

export default router
export {
  routes
};
